export default {
  baseURL: process.env.VUE_APP_BASEURL,
  sentryDNS: process.env.VUE_APP_SENTRY,
  env: process.env.VUE_APP_ENVAPP,
  sentryRelease: process.env.VUE_APP_GIT_COMMIT || 'Unknown',
  region: process.env.VUE_APP_REGION,
  isSentryEnabled: process.env.VUE_APP_IS_SENTRY_ENABLED === 'true',
}
